import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(IssueFormEmployee);

    /** @ngInject */
    function IssueFormEmployee($stateProvider) {
        $stateProvider.state('company_employee.report_issue', {
            url: '/zgloszenie',
            template: '<im-issue-form-employee></im-issue-form-employee>',
        });
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/employee/issue_form_employee.route.ts